// Display helpers for C-03 / C-03a / S-08.
import { fmtShortDate, WEEKDAYS_SHORT, weekdayOf } from '@pa/ui'

/** The viewer's time zone (S-08 shows times in it, API.md §1.4). */
export const viewerTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'

/**
 * C-03a "Slot": "Thu, Oct 15 · 9:00 AM". A slot start carries the clinic's offset (API.md §1.4), so its wall-clock
 * part is clinic time whichever app or viewer shows it.
 */
export function slotLabel(iso: string): string {
  const m = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/.exec(iso)
  if (!m) return iso
  const [, date = '', hh = '0', mm = '00'] = m
  const h = Number(hh)
  const hour12 = h % 12 === 0 ? 12 : h % 12
  return `${WEEKDAYS_SHORT[weekdayOf(date)] ?? ''}, ${fmtShortDate(date)} · ${String(hour12)}:${mm} ${h < 12 ? 'AM' : 'PM'}`
}

/** "Primary Care Center – Downtown" → "Downtown" (the mockup's `shortLocation`, C-03 Context). */
export const shortLocation = (name: string): string => name.split(' – ').pop() ?? name

/** C-03 Context: "Visit type · Location · Provider", or "" when none is known. */
export function contextLine(c: {
  visitType: { name: string } | null
  location: { name: string } | null
  provider: { name: string } | null
}): string {
  return [c.visitType?.name, c.location ? shortLocation(c.location.name) : undefined, c.provider?.name]
    .filter(Boolean)
    .join(' · ')
}
